(function () {
  'use strict';
  if (window.chillPinsLoaded) return;
  window.chillPinsLoaded = true;

  const STORAGE_KEY = 'chill-pins-v1';

  /* ── i18n (read from data-attrs set by Liquid) ────────────────── */
  let i18n = { empty: 'no pins yet', add: 'add to cart', loading: 'loading…', soldOut: 'sold out' };
  function loadI18n() {
    const dock = document.getElementById('chill-pin-dock');
    if (!dock) return;
    i18n.empty   = dock.dataset.i18nEmpty   || i18n.empty;
    i18n.add     = dock.dataset.i18nAdd     || i18n.add;
    i18n.loading = dock.dataset.i18nLoading || i18n.loading;
    i18n.soldOut = dock.dataset.i18nSoldOut || i18n.soldOut;
  }

  /* ── PinStore ─────────────────────────────────────────────────── */
  const PinStore = {
    _cache: null,
    _read() {
      if (this._cache) return this._cache;
      try { this._cache = JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
      catch (e) { this._cache = []; }
      return this._cache;
    },
    _write() {
      try { localStorage.setItem(STORAGE_KEY, JSON.stringify(this._cache)); } catch (e) {}
    },
    getAll()  { return this._read().slice(); },
    has(id)   { return this._read().some(p => String(p.id) === String(id)); },
    add(pin)  {
      const pins = this._read();
      if (!this.has(pin.id)) { pins.unshift(pin); this._cache = pins; this._write(); }
    },
    remove(id) { this._cache = this._read().filter(p => String(p.id) !== String(id)); this._write(); },
    count()   { return this._read().length; }
  };

  /* ── flyToDock ────────────────────────────────────────────────── */
  function flyToDock(imgSrcUrl, targetEl, onComplete) {
    const source = document.querySelector(
      '.product-media-gallery__image img, .product__media--featured img, .product__media img, .product-single__media img'
    );
    if (!source) { onComplete && onComplete(); return; }

    const sR = source.getBoundingClientRect();
    const tR = targetEl.getBoundingClientRect();

    const clone = document.createElement('div');
    clone.className = 'chill-pin-fly';
    Object.assign(clone.style, {
      position: 'fixed', zIndex: '99999', pointerEvents: 'none',
      backgroundSize: 'cover', backgroundPosition: 'center',
      backgroundImage: `url(${imgSrcUrl})`,
      top: sR.top + 'px', left: sR.left + 'px',
      width: sR.width + 'px', height: sR.height + 'px',
      borderRadius: '10px', willChange: 'transform,opacity'
    });
    document.body.appendChild(clone);

    const scaleX = 52 / sR.width;
    const scaleY = 52 / sR.height;
    const dx = (tR.left + tR.width / 2) - (sR.left + sR.width / 2);
    const dy = (tR.top  + tR.height / 2) - (sR.top  + sR.height / 2);

    clone.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '10px' },
      { transform: `translate(${dx}px,${dy}px) scale(${scaleX},${scaleY})`, opacity: 0.85, borderRadius: '12px' }
    ], { duration: 500, easing: 'cubic-bezier(0.32,0.72,0,1)', fill: 'forwards' })
      .addEventListener('finish', () => { clone.remove(); onComplete && onComplete(); });
  }

  /* ── flyToCart (arc) ─────────────────────────────────────────── */
  function flyToCart(imgSrcUrl, fromEl) {
    const target = document.querySelector('cart-icon, .header-actions__cart-icon');
    if (!target) return;

    const fR = fromEl.getBoundingClientRect();
    const tR = target.getBoundingClientRect();

    const clone = document.createElement('div');
    clone.className = 'chill-pin-fly';
    Object.assign(clone.style, {
      position: 'fixed', zIndex: '99999', pointerEvents: 'none',
      backgroundSize: 'cover', backgroundPosition: 'center',
      backgroundImage: `url(${imgSrcUrl})`,
      top: fR.top + 'px', left: fR.left + 'px',
      width: fR.width + 'px', height: fR.height + 'px',
      borderRadius: '10px', willChange: 'transform,opacity'
    });
    document.body.appendChild(clone);

    const dx = (tR.left + tR.width / 2) - (fR.left + fR.width / 2);
    const dy = (tR.top  + tR.height / 2) - (fR.top  + fR.height / 2);

    // Arc: mid-point goes upward before curving to cart
    const arcDx = dx * 0.4;
    const arcDy = dy * 0.3 - 90;

    clone.animate([
      { transform: 'translate(0px,0px) scale(1)',                              opacity: 1,    borderRadius: '10px', offset: 0    },
      { transform: `translate(${arcDx}px,${arcDy}px) scale(0.55)`,            opacity: 0.85, borderRadius: '12px', offset: 0.42 },
      { transform: `translate(${dx}px,${dy}px) scale(0.12)`,                  opacity: 0,    borderRadius: '50%',  offset: 1    }
    ], { duration: 950, easing: 'ease-in-out', fill: 'forwards' })
      .addEventListener('finish', () => clone.remove());
  }

  /* ── Dock ────────────────────────────────────────────────────── */
  const Dock = {
    el: null, stackEl: null, badgeEl: null,
    init() {
      this.el = document.getElementById('chill-pin-dock');
      if (!this.el) return;
      this.stackEl = this.el.querySelector('.chill-pin-dock__stack');
      this.badgeEl = this.el.querySelector('.chill-pin-dock__badge');
      this.el.addEventListener('click', () => Drawer.open());
      this.el.addEventListener('keydown', e => {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); Drawer.open(); }
      });
      this.render();
    },
    render(newPinId) {
      if (!this.el) return;
      const pins  = PinStore.getAll();
      const count = pins.length;
      this.badgeEl.textContent = count;
      this.el.classList.toggle('chill-pin-dock--empty', count === 0);
      this.stackEl.innerHTML = '';
      pins.slice(0, 3).forEach((pin, i) => {
        const thumb = document.createElement('div');
        thumb.className = 'chill-pin-dock__thumb' +
          (i === 0 && newPinId && String(pin.id) === String(newPinId) ? ' chill-pin-dock__thumb--new' : '');
        thumb.style.backgroundImage = `url(${pin.image})`;
        thumb.style.setProperty('--stack-i', String(i));
        this.stackEl.appendChild(thumb);
      });
    }
  };

  /* ── VariantPicker ───────────────────────────────────────────── */
  const VariantPicker = {
    el: null, imgEl: null, nameEl: null, priceEl: null, optionsEl: null, addBtn: null,
    _pin: null, _data: null, _sel: {}, _onDone: null,

    init() {
      this.el = document.getElementById('chill-variant-picker');
      if (!this.el) return;
      this.imgEl    = document.getElementById('cvp-img');
      this.nameEl   = document.getElementById('cvp-name');
      this.priceEl  = document.getElementById('cvp-price');
      this.optionsEl = document.getElementById('cvp-options');
      this.addBtn   = document.getElementById('cvp-add-btn');
      this.el.querySelector('.chill-variant-picker__backdrop').addEventListener('click', () => this.close());
      this.el.querySelector('.chill-variant-picker__close').addEventListener('click', () => this.close());
      this.addBtn.addEventListener('click', () => this._submit());
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.el.classList.contains('is-open')) this.close();
      });
    },

    open(pin, onDone) {
      if (!this.el) return;
      this._pin   = pin;
      this._onDone = onDone;
      this._sel   = {};
      this._data  = null;

      this.imgEl.style.backgroundImage = `url(${pin.image})`;
      this.nameEl.textContent  = pin.title;
      this.priceEl.textContent = _stripHtml(pin.priceFormatted);
      const vpI18n = this._vpI18n();
      this.optionsEl.innerHTML = `<p class="cvp-loading">${vpI18n.loading}</p>`;
      const vpI18n0 = this._vpI18n();
      this.addBtn.disabled = true;
      this.addBtn.textContent = vpI18n0.add;
      this.el.setAttribute('aria-hidden', 'false');
      this.el.classList.add('is-open');

      const handle = pin.url.replace(/^.*\/products\//, '').split('?')[0];
      fetch('/products/' + handle + '.js')
        .then(r => r.json())
        .then(data => { this._data = data; this._renderOptions(data); })
        .catch(() => {
          // no variants data — add with stored variantId
          this.close();
          this._doAdd(pin.variantId, onDone);
        });
    },

    close() {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
    },

    _renderOptions(data) {
      // Single default variant — skip picker
      if (data.options.length === 1 && data.options[0].name === 'Title') {
        this.close();
        this._doAdd(String(data.variants[0].id), this._onDone);
        return;
      }

      this.optionsEl.innerHTML = '';
      data.options.forEach((opt, idx) => {
        const grp = document.createElement('div');
        grp.className = 'cvp-option-group';
        const label = document.createElement('p');
        label.className = 'cvp-option-name';
        label.textContent = opt.name;
        grp.appendChild(label);

        const chips = document.createElement('div');
        chips.className = 'cvp-chips';
        opt.values.forEach(val => {
          const btn = document.createElement('button');
          btn.type = 'button';
          btn.className = 'cvp-chip';
          btn.textContent = val;
          btn.dataset.idx = idx;
          btn.dataset.val = val;
          btn.addEventListener('click', () => {
            chips.querySelectorAll('.cvp-chip').forEach(c => c.classList.remove('is-sel'));
            btn.classList.add('is-sel');
            this._sel[idx] = val;
            this._sync(data);
          });
          chips.appendChild(btn);
        });
        grp.appendChild(chips);
        this.optionsEl.appendChild(grp);
      });

      // Pre-select saved variant's options
      const saved = data.variants.find(v => String(v.id) === String(this._pin.variantId));
      if (saved) {
        saved.options.forEach((val, idx) => {
          this._sel[idx] = val;
          const chip = this.optionsEl.querySelector(`[data-idx="${idx}"][data-val="${CSS.escape(val)}"]`);
          if (chip) chip.classList.add('is-sel');
        });
        this._sync(data);
      }
    },

    _sync(data) {
      const allSel = Object.keys(this._sel).length === data.options.length;
      if (!allSel) { this.addBtn.disabled = true; return; }
      const variant = data.variants.find(v => v.options.every((val, i) => this._sel[i] === val));
      const vpI18n = this._vpI18n();
      if (variant && variant.available) {
        this.addBtn.disabled = false;
        this.addBtn.dataset.vid = variant.id;
        this.addBtn.textContent = vpI18n.add;
        const cents = variant.price;
        const prefix = (_stripHtml(this._pin.priceFormatted) || '').replace(/[\d.,\s]+.*/,'');
        this.priceEl.textContent = prefix + (cents / 100).toFixed(2);
      } else {
        this.addBtn.disabled = true;
        this.addBtn.textContent = variant ? vpI18n.soldOut : vpI18n.add;
      }
    },

    _submit() {
      const vid = this.addBtn.dataset.vid;
      if (!vid) return;
      this.addBtn.disabled = true;
      this.addBtn.textContent = '…';
      this._doAdd(vid, this._onDone);
    },

    _vpI18n() {
      const el = this.el;
      return {
        add:     (el && el.dataset.i18nAdd)     || i18n.add,
        loading: (el && el.dataset.i18nLoading) || i18n.loading,
        soldOut: (el && el.dataset.i18nSoldOut) || i18n.soldOut
      };
    },

    _doAdd(variantId, onDone) {
      const root  = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const body  = new FormData();
      body.append('id', String(variantId));
      body.append('quantity', '1');
      fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        credentials: 'same-origin',
        body
      })
        .then(r => { if (!r.ok) return r.json().then(e => { throw new Error(e.description || r.status); }); return r.json(); })
        .then(() => {
          this.close();
          // Refresh cart state silently (count update) without opening the drawer
          const drawer = document.querySelector('cart-drawer');
          if (drawer && typeof drawer._refreshDrawer === 'function') drawer._refreshDrawer();
          onDone && onDone(variantId);
        })
        .catch(() => {
          this.addBtn.disabled = false;
          this.addBtn.textContent = this._vpI18n().add;
        });
    }
  };

  /* ── Drawer ──────────────────────────────────────────────────── */
  const Drawer = {
    el: null, listEl: null,
    init() {
      this.el = document.getElementById('chill-pin-drawer');
      if (!this.el) return;
      this.listEl = document.getElementById('chill-pin-list');
      this.el.querySelector('.chill-pin-drawer__backdrop').addEventListener('click', () => this.close());
      this.el.querySelector('.chill-pin-drawer__close').addEventListener('click',   () => this.close());
      const gotoBtn = document.getElementById('chill-pin-goto-cart');
      if (gotoBtn) gotoBtn.addEventListener('click', () => this._gotoCart());
      document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && this.el.classList.contains('is-open')) this.close();
      });
    },
    open() {
      if (!this.el) return;
      this._render();
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    },
    close() {
      if (!this.el) return;
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    },
    _render() {
      if (!this.listEl) return;
      const pins = PinStore.getAll();
      if (!pins.length) {
        this.listEl.innerHTML = `<p class="chill-pin-drawer__empty">${i18n.empty}</p>`;
        return;
      }
      this.listEl.innerHTML = pins.map(pin => `
        <div class="chill-pin-item" data-pin-id="${_e(pin.id)}">
          <a class="chill-pin-item__img-link" href="${_e(pin.url)}" aria-label="${_e(pin.title)}">
            <div class="chill-pin-item__img" style="background-image:url(${_e(pin.image)})"></div>
          </a>
          <div class="chill-pin-item__info">
            <a class="chill-pin-item__title" href="${_e(pin.url)}">${_e(pin.title)}</a>
            <span class="chill-pin-item__price">${_e(_stripHtml(pin.priceFormatted))}</span>
          </div>
          <div class="chill-pin-item__actions">
            <button class="chill-pin-item__add-btn" type="button" aria-label="Add to cart" data-pin-id="${_e(pin.id)}">
              <svg width="18" height="18" viewBox="0 0 20 20" fill="none">
                <path d="M2.5 4.5h15l-1.8 9H4.3L2.5 4.5z" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"/>
                <circle cx="7.5" cy="17" r="1.2" fill="currentColor"/>
                <circle cx="13.5" cy="17" r="1.2" fill="currentColor"/>
              </svg>
            </button>
            <button class="chill-pin-item__remove-btn" type="button" aria-label="Remove pin" data-pin-id="${_e(pin.id)}">
              <svg width="16" height="16" viewBox="0 0 18 18" fill="none">
                <path d="M3 3l12 12M15 3L3 15" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
              </svg>
            </button>
          </div>
        </div>
      `).join('');

      this.listEl.querySelectorAll('.chill-pin-item__add-btn').forEach(btn => {
        btn.addEventListener('click', () => this._addToCart(btn));
      });
      this.listEl.querySelectorAll('.chill-pin-item__remove-btn').forEach(btn => {
        btn.addEventListener('click', () => this._removeItem(btn.dataset.pinId));
      });
    },
    _addToCart(btn) {
      const id   = btn.dataset.pinId;
      const pins = PinStore.getAll();
      const pin  = pins.find(p => String(p.id) === String(id));
      if (!pin) return;

      const item  = btn.closest('.chill-pin-item');
      const imgEl = item && item.querySelector('.chill-pin-item__img');

      VariantPicker.open(pin, () => {
        // cart:refresh already dispatched inside VariantPicker._doAdd
        if (imgEl) flyToCart(pin.image, imgEl);
      });
    },
    _gotoCart() {
      // Slide pin drawer down, then open cart drawer from right
      this.el.classList.remove('is-open');
      this.el.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      setTimeout(() => {
        const cartDrawer = document.querySelector('cart-drawer');
        if (cartDrawer) {
          if (typeof cartDrawer.open === 'function') cartDrawer.open();
          if (typeof cartDrawer._refreshDrawer === 'function') cartDrawer._refreshDrawer();
        }
      }, 400);
    },
    _removeItem(id) {
      const item = this.listEl.querySelector(`.chill-pin-item[data-pin-id="${id}"]`);
      if (!item) return;
      item.classList.add('is-removing');
      setTimeout(() => {
        PinStore.remove(id);
        Dock.render();
        const pinBtn = document.querySelector(`.chill-pin-btn[data-pin-id="${id}"]`);
        if (pinBtn) pinBtn.classList.remove('is-pinned');
        this._render();
      }, 380);
    }
  };

  /* ── Helpers ─────────────────────────────────────────────────── */
  function _e(str) {
    return String(str || '').replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');
  }

  // Strip HTML tags from money strings (Shopify formatMoney can return
  // <span class=money>₺290</span> — we want plain "₺290" for display).
  function _stripHtml(str) {
    if (!str) return '';
    if (!/</.test(str)) return str; // fast path: no HTML
    var tmp = document.createElement('span');
    tmp.innerHTML = str;
    return tmp.textContent || str;
  }

  /* ── Pin buttons ─────────────────────────────────────────────── */
  function initPinButtons() {
    document.querySelectorAll('.chill-pin-btn:not([data-pin-init])').forEach(btn => {
      btn.setAttribute('data-pin-init', '');
      const id = btn.dataset.pinId;
      if (PinStore.has(id)) btn.classList.add('is-pinned');

      btn.addEventListener('click', () => {
        if (PinStore.has(id)) {
          PinStore.remove(id);
          btn.classList.remove('is-pinned');
          Dock.render();
        } else {
          const pin = {
            id:             btn.dataset.pinId,
            variantId:      btn.dataset.pinVariant,
            title:          btn.dataset.pinTitle,
            price:          btn.dataset.pinPrice,
            priceFormatted: btn.dataset.pinPriceFormatted,
            image:          btn.dataset.pinImage,
            url:            btn.dataset.pinUrl
          };
          PinStore.add(pin);
          btn.classList.add('is-pinned');
          const dock = document.getElementById('chill-pin-dock');
          if (dock) flyToDock(pin.image, dock, () => Dock.render(pin.id));
          else Dock.render(pin.id);
        }
      });
    });
  }

  /* ── Init ────────────────────────────────────────────────────── */
  function init() {
    loadI18n();
    Dock.init();
    Drawer.init();
    VariantPicker.init();
    initPinButtons();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
